import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";


import { HashRouter } from "react-router-dom";
import { ConfigProvider } from "antd";

const LOGO_BLUE = "#1f4ea1";
const LOGO_BLUE_LIGHT = "#3c94c8";
const LOGO_ORANGE = "#f0a026";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: LOGO_BLUE,
          colorInfo: LOGO_BLUE,
          colorLink: LOGO_BLUE,
          colorLinkHover: LOGO_BLUE_LIGHT,
          colorWarning: LOGO_ORANGE,
          colorText: "#0a2034",
          colorTextHeading: LOGO_BLUE,
          colorBgContainer: "#ffffff",
        },
        components: {
          Table: {
            headerBg: "#1f4ea1",
            headerColor: "#f1ce57",
          },
          Menu: {
            itemColor: LOGO_BLUE,
            itemHoverColor: LOGO_BLUE,
            itemSelectedColor: "#ffffff",
            itemSelectedBg: LOGO_ORANGE,
            darkItemColor: LOGO_BLUE,
            darkItemHoverColor: LOGO_BLUE,
            darkItemSelectedColor: "#ffffff",
            darkItemSelectedBg: LOGO_ORANGE,
            darkItemBg: "#ffffff",
            darkSubMenuItemBg: "#ffffff",
          },
          Button: {
            colorPrimary: LOGO_BLUE,
            colorPrimaryHover: LOGO_BLUE_LIGHT,
            colorPrimaryActive: "#173f85",
          },
          Tabs: {
            itemColor: LOGO_BLUE,
            itemHoverColor: LOGO_BLUE_LIGHT,
            itemSelectedColor: LOGO_BLUE,
            inkBarColor: LOGO_ORANGE,
          },
        },
      }}
    >
      <HashRouter>
        <App />
      </HashRouter>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
